import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-backhome',
    templateUrl: './block-backhome.component.html',
})

export class BlockBackHomeComponent extends BlockAbstractComponent implements OnInit {

}
